import React from "react";

import Modal from "@stadium/ui/src/components/ModalNew";
import {
  ModalContent,
  ModalDialog,
} from "@stadium/ui/src/components/ModalNew/utils";

import InstantSearchWrapper from "@stadium/shared/src/components/instant-search";
import Search from "@components/modals/search-template/search";

import styles from "./main.module.scss";

const emptyObj = {};

const SearchTemplateModal = ({ data = emptyObj, closeModal }) => {
  return (
    <Modal closeModal={closeModal} newModal mobileBottomDrawer>
      <ModalDialog className={styles.searchModalDialog}>
        <ModalContent>
          <InstantSearchWrapper isSearch>
            <Search data={data} closeModal={closeModal} />
          </InstantSearchWrapper>
        </ModalContent>
      </ModalDialog>
    </Modal>
  );
};

export default SearchTemplateModal;
